export const checkOperatorPlatform = (platformId: string): boolean => {
  if (platformId !== null && platformId.includes('CL')) return true
  return false
}
